import { connect } from 'react-redux';
import { withHandlers, compose } from 'recompose';

import fetchData, { getDates } from '../shared/FetchDataContainer';
import { fullName } from '../../../common/helpers/users';
import withTimezone from '../../../auth/utils/withTimezone';
import { activeShopName, isBarberUser } from '../../../auth/selectors';
import {
  fetchShopInventoryReport,
  fetchBarberInventoryReport,
  getShopInventoryReportCsv,
  getBarberInventoryReportCsv,
} from '../actions';
import { getProductInventoryActionFilters } from '../../../main/reports/selectors';


const mapStateToProps = state => ({
  shop: state.auth.shop,
  shopName: activeShopName(state),
  barberUser: state.auth.barberUser,
  isBarberUser: isBarberUser(state),
  report: state.products.productInventory,
  startDate: state.reports.startDate,
  endDate: state.reports.endDate,
  productInventoryActions: getProductInventoryActionFilters(state),
});

const mapDispatchToProps = {
  fetchShopInventoryReport,
  fetchBarberInventoryReport,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withTimezone,
  withHandlers({
    getSelectedActions: props => () => props.productInventoryActions
      .filter(({ checked }) => checked)
      .map(action => action.value),
  }),
  withHandlers({
    getReport: props => () => {
      const id = props.isBarberUser ? props.barberUser.id : props.shop;
      const fetchReport = props.isBarberUser ? props.fetchBarberInventoryReport : props.fetchShopInventoryReport;
      const { start, end } = getDates(props);

      return fetchReport(id, start.toJSON(), end.toJSON(), props.getSelectedActions());
    },
    getCsv: props => () => {
      const id = props.isBarberUser ? props.barberUser.id : props.shop;
      const name = props.isBarberUser ? fullName(props.barberUser) : props.shopName;
      const fetchReportCsv = props.isBarberUser ? getBarberInventoryReportCsv : getShopInventoryReportCsv;
      const { start, end } = getDates(props);

      return fetchReportCsv(id, name, start.toJSON(), end.toJSON(), props.timezone, props.getSelectedActions());
    },
  }),
  fetchData,
);

export default enhance;
